// src/components/job-engine/DashboardCharts.tsx
import React from "react";
import { Stack, Text } from "@fluentui/react";
import {
  LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, CartesianGrid,
  BarChart, Bar,
} from "recharts";
import type { DashboardChartSeries } from "@/api/jobEngine";

interface Props { data: DashboardChartSeries | null; }

const DashboardCharts: React.FC<Props> = ({ data }) => {
  if (!data) return <Text>Loading charts…</Text>;
  return (
    <Stack tokens={{ childrenGap: 24 }}>
      <Stack tokens={{ childrenGap: 6 }}>
        <Text variant="mediumPlus" styles={{ root: { fontWeight: 600 } }}>Throughput ({data.window})</Text>
        <div style={{ width: "100%", height: 180 }}>
          <ResponsiveContainer>
            <LineChart data={data.throughput}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="timestamp" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} width={40} />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="succeeded" stroke="#107c10" />
              <Line type="monotone" dataKey="failed"    stroke="#d13438" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </Stack>

      <Stack tokens={{ childrenGap: 6 }}>
        <Text variant="mediumPlus" styles={{ root: { fontWeight: 600 } }}>Error rate ({data.window})</Text>
        <div style={{ width: "100%", height: 150 }}>
          <ResponsiveContainer>
            <LineChart data={data.errorRate}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="timestamp" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} width={40} />
              <Tooltip />
              <Line type="monotone" dataKey="rate" stroke="#d13438" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </Stack>

      <Stack tokens={{ childrenGap: 6 }}>
        <Text variant="mediumPlus" styles={{ root: { fontWeight: 600 } }}>Pickup latency p95 by handler</Text>
        <div style={{ width: "100%", height: 170 }}>
          <ResponsiveContainer>
            <BarChart data={data.pickupLatencyP95ByHandler}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="jobType" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} width={40} />
              <Tooltip />
              <Bar dataKey="p95Ms" fill="#0078d4" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Stack>
    </Stack>
  );
};

export default DashboardCharts;
